<template>
  <div class="userInfo">
    <div class="changeAvatar">
      <el-upload
        class="avatar-uploader"
        :action="action"
        :show-file-list="false"
        :on-success="handleAvatarSuccess">
        <img v-if="userInfo.headImage" :src="userInfo.headImage" class="avatar">
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>
      <span class="avatarTit">更换头像</span>
    </div>
    <div class="userNameBox userBlock">
      <label>昵称：</label>
      <el-input v-model="userInfo.name" placeholder="请输入内容"></el-input>
    </div>
    <div class="userNameBox userBlock">
      <label>性别：</label>
      <el-radio v-model="userInfo.sex" label="男">男</el-radio>
      <el-radio v-model="userInfo.sex" label="女">女</el-radio>
    </div>
    <div class="birthTimeBox userBlock">
      <label>出生日期：</label>
      <el-date-picker
        v-model="userInfo.birthday"
        type="date"
        placeholder="选择日期"
        format="yyyy 年 MM 月 dd 日"
        value-format="yyyy-MM-dd">
      </el-date-picker>
    </div>
    <div class="bindPhoneBox userBlock">
      <label>绑定手机号：</label>
      <div class="phoneInfo">
        <span>{{ userInfo.phone }}</span>
        <span @click="$router.push('/changePhone')">更换</span>
      </div>
    </div>
    <div class="userInfoSave" @click="saveUserInfo" v-throttle>保存</div>
  </div>
</template>

<script>
import imagesUrl from '../../../assets/imagesUrl'
import api from '@/api'
import { listSearchMixin } from '@/config/mixin'
import {mapGetters, mapMutations} from 'vuex'

export default {
  mixins: [listSearchMixin],
  name: 'userInfo',
  data () {
    return {
      headUrl: imagesUrl.avatar,
      userName: 'Curmudgeons',
      gender: '1',
      birthTime: '',
      userInfoData: {},
      avatarImg: '',
      action: api.upload
    }
  },
  mounted () {
    // this.getUserInfo()
  },
  computed: {
    ...mapGetters([
      'userInfo' // 用户信息
    ])
  },
  methods: {
    ...mapMutations({
      setUserInfo: 'SET_USERINFO', // 修改用户信息
      setAVATR: 'SET_AVATAR' // 修改用户信息
    }),
    getUserInfo () {
      let self = this
      let params = {
        url: api.getUser,
        method: 'GET'
      }
      self.sendReq(params, (res) => {
        if (res.code === '200') {
          self.setUserInfo(res.data)
        }
      })
    },
    saveUserInfo () {
      // console.log(this.userInfo, 'userInfo')
      let self = this
      let params = {
        url: api.update,
        method: 'PUT',
        data: {
          name: self.userInfo.name,
          sex: self.userInfo.sex,
          birthday: self.userInfo.birthday,
          headImage: self.userInfo.headImage
        }
      }
      self.sendReq(params, (res) => {
        if (res.code === '200') {
          self.$message({
            message: '修改成功！',
            type: 'success'
          })
          this.getUserInfo()
        }
      })
    },
    // 上传头像
    handleAvatarSuccess (res) {
      this.setAVATR(res.data.url)
      this.saveUserInfo()
    }
  }
}
</script>

<style lang="scss" scoped>
.userInfo {
  padding: 30px;
  border: 1px solid #E5E5E5;
  .changeAvatar {
    width: 134px;
    height: 134px;
    position: relative;
    .avatar {
      width: 100%;
    }
    .avatarTit {
      height: 30px;
      line-height: 30px;
      position: absolute;
      bottom: 0;
      font-size: 16px;
      background: rgba(84, 84, 84, 0.5);
      width: 100%;
      text-align: center;
      color: #ffffff;
      cursor: pointer;
    }
  }
  .userNameBox {
    >>> .el-input {
      width: 180px;
    }
  }
  .userBlock {
    margin-top: 30px;
    display: flex;
    align-items: center;
    label {
      font-weight: normal;
      font-size: 16px;
      color: #666666;
    }
  }
  .bindPhoneBox {
    .phoneInfo {
      font-size: 16px;
      span {
        margin-right: 15px;
        text-decoration: underline;
        cursor: pointer;
      }
      span:nth-child(1) {
        color: #333333;
        text-decoration: none;
        cursor: default;
      }
      span:nth-child(2) {
        color: $mainColor;
      }
      span:nth-child(3) {
        color: #666666;
      }
    }
  }
  .userInfoSave {
    margin: 50px 0 0 80px;
    width: 115px;
    height: 30px;
    line-height: 30px;
    background: #FFFFFF;
    border: 1px solid $mainColor;
    border-radius: 4px;
    text-align: center;
    color: $mainColor;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/userCenter/userInfo/userInfo.vue